import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-logout.svg";
import * as styles from "./Icon.module.scss";

type LogoutProps = React.SVGProps<SVGSVGElement>;

export const Logout = ({ className, ...props }: LogoutProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
